import useLearningCenter from "~/hooks/use-learning-center";

import { editorStateMap } from "../condition-options";

export interface ActiveGoalButtonTextProps {
  conditionMetText: string;
  conditionNotMetText: string;
  stateToShowInEditor: string;
  isEdit: boolean;
  "data-testid"?: string;
}

export const ActiveGoalButtonText = ({
  conditionMetText,
  conditionNotMetText,
  stateToShowInEditor,
  isEdit,
  "data-testid": dataTestId,
}: ActiveGoalButtonTextProps) => {
  // Drive the CTA copy off the learner's real active goal. The hook is
  // SSR-safe: registered data resolves from the root loader and guest data
  // seeds empty for SSR parity (hydrating from localStorage after mount), so
  // there's no hydration mismatch. `getActiveGoal()` returns the active Goal
  // or null. A parse error falls back to the not-met (no active goal) copy.
  const { getActiveGoal, error: lcError } = useLearningCenter();
  if (lcError)
    console.warn(
      "Learning Center data error; falling back to no-active-goal copy",
      lcError,
    );
  const hasActiveGoal = !lcError && getActiveGoal() != null;

  const renderButtonChildren = () => {
    if (isEdit) {
      return stateToShowInEditor === editorStateMap.CONDITION_MET
        ? conditionMetText
        : conditionNotMetText;
    } else {
      return hasActiveGoal ? conditionMetText : conditionNotMetText;
    }
  };

  return <div data-testid={dataTestId}>{renderButtonChildren()}</div>;
};
